import React, { useEffect, useState } from 'react';
import { Autocomplete, CircularProgress, Grid, TextField } from '@mui/material';
import NuevoSocioForm from './NuevoSocioForm';
import Api from "../../../../utils/services/Api";
import EndPoints from "../../../../utils/services/EndPoints";
import { makeStyles } from '@mui/styles';
import { useEdicionSocio } from '../../../../context/socio/use-edicion-socio';
import { Box } from '@mui/system';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  endAdornment: {
    top: 'auto',
  },
}));

const NuevoSocio = ({
  codigoSocioPreseleccionado,
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { infoSocio, setInfoSocio } = useEdicionSocio()
  const [isLoading, setIsLoading] = useState(true);
  const [listPersonByEntity, setListPersonByEntity] = useState([]);

  const cargarInformacionPersona = async (codigo) => {
    try {
      const response = await Api(EndPoints.obtienePersonCodigo + "/" + codigo + "/", "GET", null)
      setInfoSocio(response)
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" })
    }
  };

  const onChangeBuscaPersona = (_, selected) => {
    const { codigo } = selected
    if (codigo) {
      cargarInformacionPersona(codigo);
    }
  };

  const getPersonByEntityList = async () => {
    try {
      const response = await Api(EndPoints.listPerson, "GET", null)
      setListPersonByEntity(response);
      setIsLoading(false)
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" })
    }
  };

  useEffect(() => {
    getPersonByEntityList();
  }, []);

  useEffect(() => {
    if (codigoSocioPreseleccionado) {
      cargarInformacionPersona(codigoSocioPreseleccionado);
    }
  }, [codigoSocioPreseleccionado]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Autocomplete
          id="busqueda-socio"
          classes={{
            endAdornment: classes.endAdornment
          }}
          disableClearable
          options={listPersonByEntity}
          getOptionLabel={option => `${option.codigo}  -  ${option.numeroIdentificacion}  -  ${option.nombres}`}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Seleccionar socio"
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                type: 'search',
                ...(isLoading && ({
                  endAdornment:
                    <Box display="block">
                      <CircularProgress color="inherit" size={20} />
                    </Box>

                })),
              }}
            />
          )}
          onChange={onChangeBuscaPersona}
          isOptionEqualToValue={(option, value) => option.codigo === value.codigo}
          {...(
            codigoSocioPreseleccionado && {
              value: listPersonByEntity.find(option => option.codigo === codigoSocioPreseleccionado),
              disabled: true
            }
          )}
        />
      </Grid>
      {
        infoSocio.datosBasicosMs && (
          <NuevoSocioForm
            listPersonByEntity={listPersonByEntity}
          />
        )
      }
    </Grid>
  )

}

export default NuevoSocio